export function setMeta(attr, key, value) {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", value);
}

export function setCanonical(url) {
    let el = document.head.querySelector('link[rel="canonical"]');
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
    }
    el.setAttribute("href", url);
    setMeta("property", "og:url", url);
}

export function setPageMeta({ title, description, image }) {
    document.title = title;
    setMeta("property", "og:title", title);
    setMeta("name", "twitter:title", title);
    if (description) {
        setMeta("name", "description", description);
        setMeta("property", "og:description", description);
        setMeta("name", "twitter:description", description);
    }
    if (image) {
        setMeta("property", "og:image", image);
        setMeta("name", "twitter:image", image);
    }
}
